import React from "react";
import { Text, View, Image, StyleSheet } from "react-native";

const CategoryElement = ({ item }) => {
    const {name, image} = item;
    let ImageFromURL = { uri: image };
    return (
        <View style={styles.viewStyle}>
            <Image style={styles.imageStyle} source={ImageFromURL} />
            <Text style={styles.elementText}>{name}</Text>
        </View>
    );
};

const styles = StyleSheet.create({
    viewStyle: {
        backgroundColor: 'white',
        margin: 5,
        borderRadius: 10
    },
    elementText: {
        fontSize: 14,
        textAlign: 'center',
        width: 107,
        padding: 10
    },
    imageStyle: {
        height: 107,
        width: 107,
        resizeMode: 'cover',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10
    }
});

export default CategoryElement;